/**
 *
 * jQuery contact map made as simple as possible.
 *
 * Copyright 2016, Martin Černý
 * All rights reserved.
 *
 * version 1.00
 *
 */

(function($){
	$.fn.simpleMap = function(options){

		/* Default settings */
		var defaults = $.extend({
			center: [0,0], // center of the map
			styles: null, // gmaps styles
			zoom: 10, // zoom
			infoWindow: 'The infowindow content',
			showInfoWindow: false,
			disableDefaultUI: true,
			fixRoboto: false,
			icon: null,
			pinAttributes: {
				size: new google.maps.Size(32,51),
				scaledSize: new google.maps.Size(32,51),
				origin: new google.maps.Point(0,0),
				anchor: new google.maps.Point(16,51)
			}
		},options);

		// this extends default settings with HTML5 "data-" attributes
		var settings = $.extend(true, {}, defaults, this.data());

		/**
		 * =================
		 * BASE VARS
		 * =================
		 */
		var ele = this,
			map = {};

		/**
		 * ===============
		 * INIT
		 * ===============
		 */
		var init = function () {
			fixRoboto();
			map.map = new google.maps.Map($(ele)[0], {
				zoom: settings.zoom,
				center: new google.maps.LatLng(settings.center[0], settings.center[1]),
				styles: settings.styles,
				disableDefaultUI: settings.disableDefaultUI
			});
			map.infoWindow = new google.maps.InfoWindow({
				pixelOffset: new google.maps.Size(0, 0)
			});
			markersInit();
			$(window).resize(function(){
				map.map.setCenter(new google.maps.LatLng(settings.center[0], settings.center[1]));
				google.maps.event.trigger(map.map, 'resize');
			});
		};

		/** Markers & info popups */
		var markersInit = function(){
			var pin = settings.pinAttributes;
			pin.url = settings.icon;

			var marker = new google.maps.Marker({
				position: new google.maps.LatLng(settings.center[0], settings.center[1]),
				map: map.map,
				icon: pin
			});
			if(settings.showInfoWindow){
				infoWindowReset(map.map, map.infoWindow, marker);

				google.maps.event.addListener(marker, 'click', function() {
					infoWindowReset(map.map, map.infoWindow, marker);
				});
			}
		};
		/** /markers & info popups */

		/** Infowindow reset */
		var infoWindowReset = function(map, info, markerItem){
			info.close();
			info.setContent('<div class="pin-info">' + settings.infoWindow + '</div>');
			info.open(map,markerItem);
		};
		/** /Infowindow reset */

		/** Roboto font fix */
		var fixRoboto = function(){
			if(settings.fixRoboto = true){
				var head = document.getElementsByTagName('head')[0];
				var insertBefore = head.insertBefore;
				head.insertBefore = function (newElement, referenceElement) {
					if (newElement.href && (newElement.href.indexOf('http://fonts.googleapis.com/css?family=Roboto') === 0 || newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0)) {
						//console.info('Prevented Roboto from loading!');
						return;
					}
					insertBefore.call(head, newElement, referenceElement);
				};
			}
		};
		/** /Roboto font fix */

		/** Fire it! */
		google.maps.event.addDomListener(window, 'load', init());

		/** And finally return the object for chaining */
		return ele;
	};
}(jQuery));